<template>
  <popup ref="popup" :loading="popupLoading" @beforeClose="close">
    <div slot="body" style="padding-top: 20px">
      <div class="operator">
        <el-row>
          <el-col :span="4" :offset="6">得分：{{ `${score} / ${maxScore}` }}</el-col>
        </el-row>
      </div>
      <el-form class="dataForm" ref="form" :disabled="disabled" :inline="true">
        <el-row>
          <el-col :span="24">
            <!-- 简答、论述、编程题 回显 问答卷 -->
            <div v-if="questionArray">
              <el-card v-for="(qu, idx1) in questionArray" :key="idx1 + '5'">
                <span v-if="qu.question">
                <div v-if="idx1 == 0">
                  <el-divider content-position="left">
                    <span style="color:#CC0000">{{ qu.i + 1 }}.问答</span></el-divider>
                </div>
                <b>{{ idx1 + 1 }}.</b>
                <textarea cols="100" rows="3" disabled v-model="qu.question.title"></textarea> 

                <b style="color:#00CC00">[{{ qu.qscore }}分]</b><span >得分判定：{{ qu.rscore || 0 }} 分。</span> <br />
                <!-- <textarea :readonly="true" name="" id="" cols="100%" rows="5" v-model="qu.flag"></textarea> -->
                 <div v-for="(ch, idx2) in qu.question.choiceList" :key="idx2 + '11'">
                  <el-button :class="ch.o==qu.flag?'bg-purple':''" plain  size="mini">{{ ch.o }}.{{ ch.n }}</el-button>
                </div>
                <div style="width: 50%" v-if="qu.rigthAnsr">
                  
                  <br />
                  <span class="title-color-red">标准答案：<br /><span style="color: #777;font-size: 12px;"
                      v-html="qu.rigthAnsr"></span></span>
                  <br />
                  <span class="title-style-bold margin-top-20">题目解析:</span><br />
                  <!-- 题目解析按钮 -->
                  <el-button v-if="false"  :type="qu.stuanswer?'info':'success'"    size="mini" @click="getCurrentAnalysis(qu)"> {{qu.stuanswer?'查看':'更新'}}答案-解析222</el-button>
                </div>
                </span>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-form>
        <!-- 解析弹出面板 -->
        <el-dialog title="更新答案解析" :visible.sync="dialogFormVisible" :append-to-body="true" ref="analysisForm">
        <el-form :model="currentQuestion">
          <el-form-item label="答案">
            <el-input type="textarea" v-model="currentQuestion.rigthAnsr" rows="4"></el-input>
          </el-form-item>
          <el-form-item label="解析">
            <el-input type="textarea" v-model="currentQuestion.analysis" rows="8"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('cancel')">关 闭</el-button>
          <el-button type="danger"  v-if="!this.currentQuestion.stuanswer" @click="submitForm()">提交更新</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer">
      <el-row>
        <el-col :span="21">
          <el-button v-if="!disabled" type="info" :loading="confirmLoading" @click="close()">关 闭</el-button>
        </el-col>
        <el-col :span="3"> </el-col>
      </el-row>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopupSta.vue";
import FillInTheBlanks from "@/components/exams/FillInTheBlanks.vue";
import api from "@/api/exams/exams/exams.js";
import apiAnsr from "@/api/exams/exams/answers.js";

export default {
  components: {
    popup,
    FillInTheBlanks,
  },
  data() {
    return {
      popupLoading: false,
      disabled: false,
      confirmLoading: false,

      flag1: 0,

      parameter: {}, //exam
      kid: "", //考试id
      stuid: "", //当前学生
      stus: [], //考试的学生列表
      stuIndex: 0, //当前的学生 在数组中的位置

      exp: {}, //试卷
      expId: null, //试卷ID
      exmCnt: 0, //考试的人数
      score: 0, //当前得分
      maxScore: 100, //试卷总分
      typeTxArr: [],
      stuAnwser: {}, //学生自己答案

      //题类型位置
      choice_question: { show: false },
      //题数组
      questionArray: { t1: [], t2: [], t3: [], t4: [], t5: [], t6: [], t7: [] },
      dialogFormVisible: false, // 题目解析弹出是否可见
      currentQuestion: {}, // 当前题目的解析
      searchParams: {},

      // 是否判卷
      isjudged: 0,
      times: {},
    };
  },

  methods: {
    //获取一个考生的答案
    getOneAnwser() {
      api.getOneAnswers({ kid: this.kid, sid: this.stuid }, (res) => {
        this.stuAnwser = res.data;
        // 获取试卷得分
        this.score = this.stuAnwser.score;
        // 获取学生答案
        this.questionArray = JSON.parse(this.stuAnwser.answer);
        console.log("学生答案", this.questionArray);
        //手动强制刷新
        this.$forceUpdate();
      });
    },
    //打开弹框
    open(kid, sid, title) {
      this.kid = kid;
      console.log("sid",sid);
      this.stuid = sid;
      this.getOneAnwser();
      this.$refs.popup.open(title, "85%");
    },
    close(done) {
      this.$refs.popup.closeCallback();
      //退出初始化参数
      this.score = 0;
      this.popupLoading = false;
      this.disabled = false;
      this.confirmLoading = false;
      this.parameter = {};
      this.flag1 = 0;
      this.choice_question = { show: false };
      this.searchParams = {};
      this.currentQuestion = {};
      this.questionArray = {
        t1: [],
        t2: [],
        t3: [],
        t4: [],
        t5: [],
        t6: [],
        t7: [],
      };
    },

    // 初始化题目解析表单
    resetForm(status) {
      this.dialogFormVisible = false;
    },
    // 获取当前题目的解析内容
    getCurrentAnalysis(data) {
      this.currentQuestion = data;
      console.log(" this.currentQuestion", this.currentQuestion)
      this.dialogFormVisible = true;
    },
    moveStu(flag) {
      //下一位
      console.log("stus", this.stus);
      this.stuIndex += flag;

      //this.student = this.studentList[this.stuIndex]
      this.stuid = this.stus[this.stuIndex].id;

      this.score = 0;

      this.stuAnwser = {};
      this.getOneAnwser();
    },submitForm(){

        //取得自己
        let userInfo = this.$caches.user.get();

        //封装"{'sn':'张三','uptm':'2023-12-03','ansr':'fdsgfdsgsfd方当时的萨达发顺丰范德萨','anys':'发带古风丝带刚好是饭点干撒的'}"
         let   stuanswer ={sn:userInfo.name,uptm:new Date().format("yyyy-MM-dd"),
                           ansr:this.currentQuestion.rigthAnsr,anys:this.currentQuestion.analysis  };

         //提交学生答案更新
         apiAnsr.updateStuAnsr({id:this.currentQuestion.id, stuanswer: JSON.stringify(stuanswer)  },res=>{
                //刷新显示
                this.currentQuestion.stuanswer ="xxx"
                this.dialogFormVisible = false;
         });

    }
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.text {
  display: inline-block;
  padding: 0 20px;
}

.operator {
  position: absolute;
  top: 50px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 999;
}

.title-style-bold {
  color: #000;
  font-weight: bold;
}

.title-color-red {
  color: red;
}

.margin-top-20 {
  margin-top: 20px;
  display: block;
}

.update-note {
  display: block;
  margin-top: 20px;
}

.el-card,
textarea {
  margin-top: 10px;
}

textarea {
  padding: 10px 5px;
  margin-bottom: 10px;
}

.el-button {
  margin: 5px 0;
}
</style>
